<article class="unauthorized-page">
  <div class="page-container">
    <div class="page-message-container">
      <div class="page-message">
        <h1>
          401!
        </h1>
        <p>
          Sorry, you are not authorized <br />
          to access this resource.
        </p>
        <div class="page-message-buttons">
          <button mat-button color="primary" (click)="back()" *ngIf="showBackButton">
            Back
          </button>
          <button mat-flat-button color="primary" (click)="login()">
            Login
          </button>
        </div>
      </div>
      <div class="page-message-message-icon">
        <img src="assets/images/icons/not-found-cloud.svg" alt="401 image" width="128" height="128" />
      </div>
    </div>
  </div>
</article>
